module.exports = __webpack_public_path__ + "static/slide2-8d7a8e00d0008b978c154eb9d40b9b7e.png";